module.exports = __webpack_public_path__ + "img/kyano-business-card.d3906af4.svg";